import { useGetIdentity } from "@refinedev/core";
import { Navigate, Outlet } from "react-router";
import type { UserInfo } from "../types/auth";
import { isCyberAdmin } from "../types/auth";
import { LoadingSpinner } from "./common/LoadingSpinner";

/**
 * Route guard más estricto que `AdminRoute`: solo Cyber Admin
 * (user_type=1) — el equipo interno de Cyberagropolis con acceso
 * global sin scope por país.
 *
 * `AdminRoute` acepta también a los ESA Admin (user_type=2), lo que
 * incluye al perfil Eurosemillas (portfolio-scoped). Este guard se
 * usa para el backoffice global (`/admin/*` — usuarios, catálogos,
 * ticket-categories, etc.) donde el ESA Admin no debe poder entrar
 * porque acabaría viendo/tocando datos fuera de su portfolio.
 *
 * A los no-Cyber Admin los redirigimos al home; el `RoleBasedHomeRedirect`
 * decide después dónde toca aterrizar según el rol.
 */
export const CyberAdminRoute = () => {
  const { data: identity, isLoading } = useGetIdentity<UserInfo>();
  if (isLoading) {
    return <LoadingSpinner fullScreen tip="Checking permissions..." />;
  }
  if (!isCyberAdmin(identity)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};
